import Box, { BoxProps } from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import classes from './Footer.module.scss';

export default function Footer({
  children,
  divider = true,
  ...rest
}: FooterProps) {
  return (
    <Box {...rest}>
      {divider && <Divider />}
      <div className={classes.children}>{children}</div>
    </Box>
  );
}

export interface FooterProps extends BoxProps {
  divider?: boolean;
}
